<template>
  <div>
    <!-- <span class="pdp__review-stars shopify-product-reviews-badge" v-if="!settings.hideReviews && this.reviewSource === 'shopify'" :data-id="product.id"></span>
      <div class="yotpo bottomLine"
        v-else
        :data-appkey="this.reviewAppKey"
        :data-domain="this.domain"
        :data-product-id="product.id"
        :data-name="product.title"
        :data-image-url="`https:${product.images[0].src}`"></div> -->
  </div>
</template>

<script>
export default {
  name: 'ProductReviewsBadge',
  props: {
    product: Object,
    settings: Object
  },
  data () {
    return {
      reviewSource: window.bvaccel && window.bvaccel.reviewSource,
      reviewAppKey: window.bvaccel && window.bvaccel.reviewAppKey,
      domain: window.bvaccel && window.bvaccel.shop.domain
    }
  }
}
</script>

<style></style>
